import { createContext } from 'react';

export const SSOActionsContext = /*#__PURE__*/ createContext<{
  API: any; // formApi
  FormCTAConfig: any;
}>({
  API: null,
  FormCTAConfig: null,
});
